import React from "react";
import "./AccessDenied.css";

export default function AccessDenied() {
  return (
    <div className="access-body">
      <i className="fa fa-lock" style={{ fontSize: 180, color: "lightgrey" }}></i>
      <h2 className="denied-h2">
        <strong>Access denied</strong>
      </h2>
      <h4>You don't have permission to access this page.</h4>
      <h4>Contact an administrator to get permission or go back to home page and browse other pages.</h4>
    </div>
  );
}
